// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__13q2L","variant-outline":"styles_variant-outline__3-mSQ","fullWidth":"styles_fullWidth__3RBsd"};